import { Dialog } from "@mui/material";
import { StyledDialog } from "./DialogStyles";
import ModalHeader from "./ModalHeader";
import ModalContent from "./ModalContent";
import ModalActions from "./ModalActions";

interface TransactionDetailsModalProps {
    open: boolean;
    onClose: () => void;
    detailsData: any;
    isDetailsLoading: boolean;
}

const TransactionDetailsModal = ({
                                     open,
                                     onClose,
                                     detailsData,
                                     isDetailsLoading
                                 }: TransactionDetailsModalProps) => {
    const selectedTransaction = detailsData?.data?.[0];

    // Transform the data to match what TransactionDetails expects
    const modalItem = selectedTransaction ? {
        ...selectedTransaction,
        amount: selectedTransaction.req_total_price,
        authority: selectedTransaction.tracking_code,
        payer_name: selectedTransaction.shop,
        status: 1,
    } : null;

    return (
        <StyledDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <ModalHeader onClose={onClose} />
            <ModalContent
                isLoading={isDetailsLoading}
                transactionData={modalItem}
            />
            <ModalActions
                selectedTransaction={modalItem} // Pass the transformed data
            />
        </StyledDialog>
    );
};

export default TransactionDetailsModal;